import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { useLanguage } from '@/contexts/LanguageContext';

export const AboutFAQ = () => {
  const { language } = useLanguage();

  const faqs = language === 'fr' ? [
    {
      q: "Qui est Gaius ?",
      a: "Gaius est un organisme de formation spécialisé en intelligence artificielle pour les professionnels du droit. Notre équipe réunit avocats et experts tech pour proposer des formations certifiées, des audits stratégiques et des solutions IA sur-mesure."
    },
    {
      q: "Pourquoi le nom Gaius ?",
      a: "Gaius est un juriste romain du IIe siècle dont les Institutes ont structuré un droit fragmenté en un cadre cohérent et enseignable, posant les fondations du Corpus Juris Civilis. Comme lui, nous structurons l'adoption de l'IA juridique pour la rendre rigoureuse et accessible."
    },
    {
      q: "Gaius est-il un organisme de formation certifié ?",
      a: "Oui. Nos formations sont éligibles à la formation continue obligatoire des avocats (FCO), au financement OPCO et FIF-PL. Chaque module donne lieu à une attestation reconnue."
    },
    {
      q: "À qui s'adressent vos formations ?",
      a: "Nos programmes s'adressent à tous les professionnels du droit : avocats (salariés et libéraux), juristes d'entreprise, directions juridiques, notaires, études notariales et magistrats."
    },
    {
      q: "Proposez-vous des formations en dehors de la France ?",
      a: "Oui, nous intervenons en France et à l'international. Nos formations sont disponibles en français et en anglais, en présentiel ou en webinaire."
    },
    {
      q: "Quelle est la différence entre formation et audit IA ?",
      a: "La formation transmet les compétences pratiques pour utiliser les outils IA au quotidien. L'audit évalue la maturité IA de votre organisation et produit une feuille de route stratégique pour l'adoption ou l'optimisation des outils."
    },
  ] : [
    {
      q: "Who is Gaius?",
      a: "Gaius is a training organization specialized in artificial intelligence for legal professionals. Our team combines lawyers and tech experts to deliver certified training, strategic audits, and custom AI solutions."
    },
    {
      q: "Why the name Gaius?",
      a: "Gaius was a 2nd-century Roman jurist whose Institutes structured fragmented law into a coherent, teachable framework — laying the foundations of the Corpus Juris Civilis. Like him, we structure legal AI adoption to make it rigorous and accessible."
    },
    {
      q: "Is Gaius a certified training organization?",
      a: "Yes. Our programs are eligible for mandatory continuing legal education (CLE), OPCO and FIF-PL funding. Each module provides a recognized certificate."
    },
    {
      q: "Who are your training programs for?",
      a: "Our programs are designed for all legal professionals: lawyers (employed and independent), in-house counsel, legal departments, notaries, and judges."
    },
    {
      q: "Do you offer training outside France?",
      a: "Yes, we operate in France and internationally. Our programs are available in French and English, on-site or via webinar."
    },
    {
      q: "What's the difference between training and an AI audit?",
      a: "Training imparts practical skills for using AI tools daily. An audit evaluates your organization's AI maturity and produces a strategic roadmap for tool adoption or optimization."
    },
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            {language === 'fr' ? 'Questions fréquentes' : 'Frequently asked questions'}
          </h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="bg-card rounded-xl border border-border px-6">
              <AccordionTrigger className="text-left text-base font-medium text-foreground hover:no-underline">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
